export default __webpack_public_path__ + "static/media/paymentMethods.4cf8f883.png";